(() => {
  const configuratorPath = '/pages/mein-sofa-1';

  const updateConfiguratorLinks = () => {
    document.querySelectorAll(`a[href^="${configuratorPath}"]`).forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      if (url.pathname !== configuratorPath || url.searchParams.has('view')) return;
      url.searchParams.set('view', 'meine-umfrage');
      link.href = `${url.pathname}${url.search}${url.hash}`;
    });
  };

  updateConfiguratorLinks();
  document.addEventListener('DOMContentLoaded', updateConfiguratorLinks, { once: true });
})();
